import { connect } from 'react-redux';
import {
  addNotification,
  removeNotification,
} from 'lib/store/notifications/actions';
import { getNotifications } from 'lib/store/notifications/selectors';

import ToastManager from './ToastManager';

const mapStateToProps = (state) => ({
  items: getNotifications(state),
});

const actions = { addNotification, removeNotification };

export default connect(mapStateToProps, actions)(ToastManager);
